import { UseQueryResult } from '@tanstack/react-query';

import { ObjectQueryState } from '../types/Api';
import { ApiError } from '../types/Error';

export const getLocalStoreObject = (key: string | null): any => {
    let returnVal = null;
    if (key && Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
        returnVal = JSON.parse(base64Decode(window.localStorage.getItem(key) as string));
    }
    return returnVal;
};

export const base64Encode = (toConvert: string): string => {
    return window
        ? window.btoa(unescape(encodeURIComponent(toConvert)))
        : btoa(unescape(encodeURIComponent(toConvert)));
};

export const base64Decode = (base64: string): string => {
    try {
        // If this throws an error, go the old way in case the user has old storage data to decode
        return window
            ? window.decodeURIComponent(escape(window.atob(base64)))
            : decodeURIComponent(escape(atob(base64)));
    } catch {
        return window ? window.atob(base64) : atob(base64);
    }
};

/* If not using Dates, functions, undefined, Infinity, RegExps, Maps, Sets, Blobs, FileLists, ImageDatas,
 sparse Arrays, Typed Arrays or other complex types */
export const deepCopyObject = (obj: unknown): any => {
    return JSON.parse(JSON.stringify(obj));
};

// Helper for single object query
export const toObjectQueryState = <T>(query: UseQueryResult<T, ApiError>): ObjectQueryState<T> => ({
    data: query.data,
    isLoading: query.isLoading,
    isFetched: query.isFetched,
    error: query.error ?? null,
    isError: query.isError
});
